import React from 'react';
import SampleEntryBaseTable from '../BaseTable';
import data from './data.json';
import { IPrintGMDSSTableData } from 'redux/app/vessel/inspector/types';

function SampleLogEntryTable2() {
    const tableData: IPrintGMDSSTableData = data;
    return (
        <div className="w-full overflow-x-auto p-4 bg-white flex flex-col justify-between py-4 mb-2 print-page-break">
            <SampleEntryBaseTable tableData={tableData} />
        </div>
    );
}

export default SampleLogEntryTable2;
